import React from 'react';
import { Close } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { StyledDrawer } from './index.style';

const CustomDrawer = ({
  title,
  children,
  anchor = 'right',
  width,
  maxWidthContent,
  minWidth,
  padding,
  titleFontSize,
  titleFontStyle,
  onClose,
  ...rest
}) => (
  <StyledDrawer
    anchor={anchor}
    maxWidthContent={maxWidthContent}
    width={width}
    minWidth={minWidth}
    padding={padding}
    titleFontSize={titleFontSize}
    titleFontStyle={titleFontStyle}
    onClose={onClose}
    {...rest}
  >
    <div className="drawer-title">
      <Typography className="title">{title}</Typography>
      <Close onClick={onClose} />
    </div>
    <div className="drawer-content">{children}</div>
  </StyledDrawer>
);

export default CustomDrawer;
